
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/mariadb",
      function () {
        return require("private-next-pages/destinations/mariadb.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/mariadb"])
      });
    }
  